import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { OptimizationCostComparison } from '@paragon/data-connections';
import { allComponentDesignsUnloaded } from '@paragon/layout-models';

export interface OptimizationCostComparisonState {
  readonly latestComparison: {
    readonly componentDesignGuid: string;
    readonly comparison: OptimizationCostComparison;
  } | null;
}

const initialState: OptimizationCostComparisonState = {
  latestComparison: null,
};

const optimizationCostComparisonSlice = createSlice({
  name: 'optimizationCostComparison',
  initialState,
  reducers: {
    setOptimizationCostComparison: (
      state,
      action: PayloadAction<{ componentDesignGuid: string; comparison: OptimizationCostComparison }>,
    ) => {
      state.latestComparison = action.payload;
    },
    clearOptimizationCostComparison: (state) => {
      state.latestComparison = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(allComponentDesignsUnloaded, () => initialState);
  },
});

export const { setOptimizationCostComparison, clearOptimizationCostComparison } =
  optimizationCostComparisonSlice.actions;
export const optimizationCostComparison = optimizationCostComparisonSlice.reducer;
